<template>
  <v-container>      
      <v-layout v-if="showLoader==false" row>
          <v-flex md-12 sm-12 xs-12>
                <div class="text-md-center text-sm-center text-xs-center">
                    <h2 v-if="!bookingInfo.IsCancelled" :style="'color:' + theme.primary.base">Your reservation is <span style="color:orange;">not</span> complete until payment is confirmed.</h2>
                    <h2 v-if="bookingInfo.IsCancelled" :style="'color:' + theme.primary.base">Your reservation has been <span style="color:orange;">cancelled.</span></h2>
                    <h2 v-if="!bookingInfo.IsCancelled && bookingInfo.Payment.Successful" :style="'color:' + theme.primary.base">The reservation's status is now <span style="color:green;">PAID.</span></h2>
                    <h2 style="color:#808080;">Booking Number is <label style="color:red;">{{getPnr}}</label>.</h2>
                    <h4 style="color:brown;">* Please keep your booking number as the reference when contacting us for any changes or support. *</h4>
                </div>
          </v-flex>
      </v-layout>
      <v-layout row v-if="paymentResult!=0 && showLoader==false">
          <v-flex>
              <v-layout row>
                  <v-spacer></v-spacer>
                  <v-flex md-3>
                    <v-card v-if="bookingInfo.Payment.Successful" flat style="border:solid 1px green;" class="mt-3">
                        <v-card-text style="color:green;text-align:center;font-size:20px;">
                            Your payment is successful.
                        </v-card-text>                     
                    </v-card>
                    <v-card v-if="paymentResult==2 && !bookingInfo.Payment.Successful" flat style="border:solid 1px red;" class="mt-3">
                        <v-card-text style="color:red;text-align:center;font-size:20px;">
                            Your payment could not be completed.
                        </v-card-text>                        
                    </v-card>                    
                  </v-flex>
                  <v-spacer></v-spacer>
              </v-layout>
          </v-flex>
      </v-layout>
      <v-layout v-if="showLoader==false && bookingInfo.ShowBackToMerchantButton" row>
          <v-flex>
              <div class="text-md-center text-sm-center text-xs-center mt-2">
                <v-btn @click="btnMerchantWebClick" color="primary">Go back to merchant website</v-btn>              
              </div>
              <form ref="frmMerchantWeb" method="get" :action="bookingInfo.MerchantUrl"></form>
          </v-flex>
      </v-layout>
      <v-layout v-if="showLoader" row>
          <v-spacer></v-spacer>
          <v-flex md-2 sm-4 xs-4>
            <v-progress-circular
            :rotate="360"
            :size="100"
            :width="15"
            :value="getLoaderPercent"
            color="teal"
            >
                {{getLoaderPercent}}
            </v-progress-circular>        
            <v-spacer></v-spacer>
          </v-flex>
      </v-layout>
      <v-layout v-if="showLoader==false && bookingInfo.IsCancelled==false" row>
          <v-spacer></v-spacer>
          <v-flex md-8 sm-8 xs-8>
            <v-card :class="'pa-' + (isMobile==true? 0:5) + ' mt-3'" flat v-if="paymentResult!=1 && bookingInfo.Payment.Successful==false">
                <span style="display:none;">Active Tab: {{getActiveTab}} {{getPaymentMethodByTabValue}} {{bookingInfo.Payment.PaymentType}}</span>
                <v-tabs
                    centered
                    color="cyan"
                    dark
                    icons-and-text    
                    :value="getDefaultTab"  
                    v-model="activeTab"          
                >
                    <v-tabs-slider color="yellow"></v-tabs-slider>

                    <v-tab :key="1" href="#tab-1" :disabled="paymentOptions.transfer==null">
                    {{isMobile? 'BL.PMNT/TRNF':'Bill Payment/Transfer'}}
                    <v-icon>account_balance</v-icon>
                    </v-tab>

                    <v-tab :key="2" href="#tab-2" :disabled="paymentOptions.card==null">
                    {{isMobile?'CARD':'Credit/Debit Card'}}
                    <v-icon>credit_card</v-icon>
                    </v-tab>

                    <v-tab :key="3" href="#tab-3" :disabled="paymentOptions.qrCode==null">
                    QR Code
                    <v-icon>dashboard</v-icon>
                    </v-tab>   

                    <v-tab-item
                    :value="'tab-1'"
                    :key="1"
                    >
                        <v-card flat>
                            <v-card-text :class="isMobile? 'pa-0':''">
                                <BillPaymentBox v-if="bookingInfo"
                                :sellingCurrency="bookingInfo.SellingCurrency"
                                :bankAccounts="getBankAccounts" 
                                :refs="[bookingInfo.Payment.Ref1,bookingInfo.Payment.Ref2]" 
                                :grandTotal="getBTFGrandTotal" 
                                :currency="bookingInfo.Currency"/>            
                            </v-card-text>
                        </v-card>
                    </v-tab-item>     

                    <v-tab-item
                    :value="'tab-2'"
                    :key="2"
                    >
                        <v-card flat v-if="paymentOptions.card!=null">
                            <v-card-text>
                                <CardPayment 
                                  v-if="bookingInfo"
                                  :sellingCurrency="bookingInfo.SellingCurrency"
                                  :isQrPayment="false" 
                                  :cardPaymentInfo="paymentOptions.card" 
                                  :searchId="sid"/>
                            </v-card-text>
                        </v-card>
                    </v-tab-item>  

                    <v-tab-item
                    :value="'tab-3'"
                    :key="3"
                    >
                        <v-card flat v-if="paymentOptions.qrCode!=null">
                            <v-card-text>
                                <CardPayment 
                                  v-if="bookingInfo"
                                  :sellingCurrency="bookingInfo.SellingCurrency"
                                  :isQrPayment="true" 
                                  :cardPaymentInfo="paymentOptions.qrCode" 
                                  :searchId="sid"/>                 
                            </v-card-text>
                        </v-card>
                    </v-tab-item>                     

                </v-tabs>
                <v-dialog v-model="showpaymentMethodChangeDialog" persistent width="500">
                  <v-card class="pa-2">
                    <v-card-title><div class="headline">Update payment method?</div></v-card-title>
                    <v-card-text>
                      <div v-if="!paymentMethodUpdateFailed">
                        The current payment method of your booking is <v-chip small color="yellow">{{tempPaymentType}}</v-chip>. To change it click <span style="color:blue;">'UPDATE PAYMENT METHOD'</span>                          
                      </div>          
                      <div v-if="paymentMethodUpdateFailed" style="text-align:center;color:red">
                        <v-icon color="red">error</v-icon> Payment method update was not successful.
                      </div>
                    </v-card-text>
                    <v-card-actions>
                      <v-layout row>
                        <v-spacer></v-spacer>
                        <v-flex sm8>
                          <v-btn color="green darken-1" flat @click="changePaymentMethod(false)">Cancel</v-btn>
                          <v-btn color="green darken-1" flat :disabled="updatePaymentMethodDisability" @click="changePaymentMethod(true)">Update payment method</v-btn>                            
                        </v-flex>
                        <v-spacer></v-spacer>
                      </v-layout>            
                    </v-card-actions>
                  </v-card>
                </v-dialog> 
            </v-card>
            <v-layout row wrap style="background-color:#fff;" class="mt-2">
                <v-flex md6 sm12 xs12>
                    <v-card :class="isMobile? 'pl-3 pr-0':'pl-5 pr-5'" flat>
                        <BK_ContactInfoBox v-if="bookingInfo" :contactInfo="bookingInfo.ContactInfo" :trip="triptype" />
                    </v-card>                       
                </v-flex>
                <v-flex md6 sm12 xs12 v-if="triptype!='M'">
                    <v-card :class="(isMobile? 'pl-0 pr-0':'pl-5 pr-5') + ' pt-3'" flat>
                        <FlightSummaryBox :flatBorder="true" :flightDetails="flightDetails"/>                        
                    </v-card>                    
                    <v-card v-if="false" :class="isMobile? 'pl-3 pr-0':'pl-5 pr-5' + ' pt-3'" flat>
                        <FlightSummaryBox :flatBorder="true" :flightDetails="flightDetails"/>
                    </v-card>                     
                </v-flex>
                <v-flex md12 sm12 xs12 v-if="triptype=='M'">
                    <v-card :class="isMobile? 'pl-0 pr-0':'pl-4 pr-5'" flat>
                    <FlightSummaryBoxMulticity v-if="triptype=='M'" :flatBorder="true" :flightDetails="flightDetails"/>
                    </v-card>
                </v-flex>
            </v-layout>
         
          </v-flex>
          <v-spacer></v-spacer>          
      </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */
import Theme from '../../theme';
import BillPaymentBox from './BillPaymentBox';
import BK_ContactInfoBox from './BK_ContactInfoBox';
import BookingService from '../../services/booking.service';
import Helper from '../helper';
import FlightSummaryBox from '../CustomControls/FlightSummaryBox';
import MockedFlightDetails from '../Passengers/mockedFlightDetails';
import CardPayment from './CardPaymentBox';
import PassengerService from '../../services/passernger.service';
import helper from '../helper';
import AgentTheme from '../../agent_theme';
import FlightSummaryBoxMulticity from '../CustomControls/FlightSummaryBoxMulticity';

export default {
    components:{
        BillPaymentBox,
        BK_ContactInfoBox,
        FlightSummaryBox,
        CardPayment,
        FlightSummaryBoxMulticity,
    },
    computed:{
        getActiveTab() {
          return this.activeTab;
        },
        getBTFGrandTotal(){
            return this.paymentOptions.transfer.grandTotal;
        },
        getCCGrandTotal(){
            return this.paymentOptions.card.grandTotal;
        },
        getQRGrandTotal(){
            return this.paymentOptions.qrCode.grandTotal;
        },
        getPaymentMethodByTabValue() {
          const tabKeys = this.tabPaymentPairs;
          const lnq = new this.$linq(tabKeys);
          const pm = lnq.where(t=> t.tab==this.activeTab).toArray()[0].pm;
          if (pm != this.tempPaymentType && this.afterSetDefaultTab) {
            this.paymentMethodUpdateFailed = false;
            this.showpaymentMethodChangeDialog = true;
          }
          return pm;
        },
        getTabValueByPaymentMethod() {
          const tabKeys = this.tabPaymentPairs;
          const lnq = new this.$linq(tabKeys);
          const tab = lnq.where(t=> t.pm==this.tempPaymentType).toArray()[0].tab;
          return tab;
        },
        getDefaultTab(){
            let tabValues = ['','BANK TRANSFER','CREDIT CARD','GB_QR_PAYMENT','SCB_QR_PAYMENT'];
            let dftTab = 0;

            if (this.bookingInfo!=null){
                let tabIndex = tabValues.indexOf( this.bookingInfo.Payment.PaymentType);
                tabIndex = tabIndex==4? 3:tabIndex;
                dftTab = "tab-" + tabIndex;
                this.activeTab = dftTab;
                this.afterSetDefaultTab = true;
            }
            //this.showpaymentMethodChangeDialog = true;
            return dftTab;
        },
        getBankAccounts(){
            let accounts = [];

            if (this.bookingInfo!=null){
                accounts = this.bookingInfo.Payment.Banks;
            }

            return accounts;
        },
        getPnr(){
            return this.bookingInfo!=null? this.bookingInfo.ShownPnr:"";
        },
        isMobile(){
            let isMobile = Helper.display.isMobile(this.$vuetify.breakpoint.name);
            return isMobile;
        },
        showLoader(){
            return (this.loaderPercents.value1+this.loaderPercents.value2+this.loaderPercents.value3>=100)==false;
        },
        getLoaderPercent(){
            return this.loaderPercents.value1+this.loaderPercents.value2+this.loaderPercents.value3;
        },
    },
    data(){
        return {
            paymentMethodUpdateFailed: false,
            updatePaymentMethodDisability: false,
            tempPaymentType: '',
            tabPaymentPairs: [
            {tab: 'tab-1', pm: 'BANK TRANSFER'},
            {tab: 'tab-2', pm: 'CREDIT CARD'},
            {tab: 'tab-3', pm: 'GB_QR_PAYMENT'},
            {tab: 'tab-4', pm: 'SCB_QR_PAYMENT'}
            ],
            afterSetDefaultTab: false,
            showpaymentMethodChangeDialog: false,
            activeTab: 'tab-1',
            theme:Theme,
            sid:"",
            bookingInfo:null,
            flightDetails:MockedFlightDetails.flightDetails,
            flightDetails2:MockedFlightDetails.flightDetails,
            paymentOptions:{
                transfer:null,
                card:null,
                qrCode:null,
            },
            paymentResult:0,
            loaderPercents:{
                value1:10,
                value2:0,
                value3:0},
            triptype:null,
            statedData: {
              sellingCurrency: null
            }
        }
    },
    created(){
        let sid = this.$route.params.sid;
        this.paymentResult = this.$route.params.pm!=null? this.$route.params.pm:0;
        this.sid = sid;      
        if (sid>0){
            this.showBookingInfo(sid);
        }else {          
            this.getSearchIdFromCookie();
        }
        Helper.display.scrollToTop();
        this.$vuetify.theme.primary.base = AgentTheme.getAgentTheme(143).colors.primary.base;

        if (this.$store.state.sellingCurrency !=null){
          this.statedData.sellingCurrency = this.$store.state.sellingCurrency;
        }
    },
    methods:{
        changePaymentMethod(change) {
          if (change){
            let paymentType = "";
            let merchantCode = "";

            if (this.activeTab == 'tab-1'){
              paymentType = this.paymentOptions.transfer.paymentCode;
              merchantCode = this.paymentOptions.transfer.merchantCode;
            } else if (this.activeTab == 'tab-2') {
              paymentType = this.paymentOptions.card.paymentCode;
              merchantCode = this.paymentOptions.card.merchantCode;
            } else if (this.activeTab == 'tab-3' || this.activeTab == 'tab-4') {
              paymentType = this.paymentOptions.qrCode.paymentCode;
              merchantCode = this.paymentOptions.qrCode.merchantCode;
            }
            this.updatePaymentMethodDisability = true;
            this.paymentMethodUpdateFailed = false;
            BookingService.changeBookingPaymentMethod(this.sid, paymentType, merchantCode).then(result => {
              this.updatePaymentMethodDisability = false;
              if (!result.error || result.error === ""){
                const tabKeys = this.tabPaymentPairs;
                const lnq = new this.$linq(tabKeys);
                const pm = lnq.where(t=> t.tab==this.activeTab).toArray()[0].pm;
                this.tempPaymentType = pm;
                this.showpaymentMethodChangeDialog = false;
              }else {
                this.paymentMethodUpdateFailed = true;
              }
            });
          }else {
            this.activeTab = this.getTabValueByPaymentMethod
            this.showpaymentMethodChangeDialog = false;
          }
        },
        btnMerchantWebClick(){
            this.$refs.frmMerchantWeb.submit();
        },
        setLoaderPercent(index, value){
            let vals=[
                this.loaderPercents.value1,
                this.loaderPercents.value2,
                this.loaderPercents.value3
            ]
            vals[index]+=value;
            this.loaderPercents = {
                value1:vals[0],value2:vals[1],value3:vals[2]
            };
        },
        showBookingInfo(sid){
            BookingService.sendInitialRequest(sid).then(rslt=>{
                let data = { searchId: sid, showBackToMerchantBtn: true, view_detail: true };
                this.$store.commit("updateWholesaleIdAndUrlId",[rslt.data.wid, rslt.data.urlId, rslt.data.mlv]);
                this.$vuetify.theme.primary.base = AgentTheme.getAgentTheme(this.wholesaleId).colors.primary.base;
                setTimeout(() => {
                    this.setLoaderPercent(0,20);
                }, 1500);
                

                BookingService.getBookingInformation(data).then(rslt=>{
                    this.setLoaderPercent(0,20);
                    this.bookingInfo = rslt.data;
                    this.tempPaymentType = this.bookingInfo.Payment.PaymentType;
                    this.buildFlightDetails();
                    this.getPaymentOptions();
                })
            });
        },
        getSearchIdFromCookie(){
            BookingService.getSearchIdFromCookie().then(rslt=>{
                let sid = rslt.data;
                if (sid>0){
                    this.sid=sid;
                    this.$router.push({name:"BookingInfoAndPaymentResult",params:{sid:sid,pm:this.paymentResult}});
                    this.$router.go();
                }else{
                    this.$router.push({name:"Error"});
                }
            });
        },
        buildFlightDetails(){
            this.flightDetails = {
                flightsOfDeparture:[],
                flightsOfReturn:[],
            }
            this.triptype=this.bookingInfo.TripType;
            if (this.bookingInfo.PnrInfo[0]!=null){
                let dSegm = this.bookingInfo.PnrInfo[0].DepartingSegments;
                let rSegm;
                if (this.bookingInfo.PnrInfo[0].ReturningSegments!=null){
                    rSegm = this.bookingInfo.PnrInfo[0].ReturningSegments;
                }
                let days = ["Sun","Mon","Tue","Wed","Thur","Fri","Sat"];

                let Segms = [dSegm];
                if (rSegm!=null) Segms.push(rSegm);
                
                for(let i =0;i<Segms.length;i++){
                    let s = i==0? dSegm:rSegm;
                    s.Items.forEach(f => {
                        let sDate = new Date(parseInt(f.StartDate.replace('/Date(', '')));
                        let eDate = new Date(parseInt(f.EndDate.replace('/Date(', '')));
                        let seg = {
                            airline: f.Airline,
                            flightNo: f.FlightNo,
                            origin: {
                                airport: {
                                    code: f.StartAirport.Code,
                                    name: f.StartAirport.Description,
                                },
                                day: days[sDate.getDay],
                                date: Helper.dateAndTime.getDateYYYYMMDD(sDate),
                                time: sDate.getHours()+""+(sDate.getMinutes()<=9? "0" +sDate.getMinutes():sDate.getMinutes()),
                            },
                            destination: {
                                airport: {
                                    code: f.EndAirport.Code,
                                    name: f.EndAirport.Description,
                                },
                                day: days[eDate.getDay],
                                date: Helper.dateAndTime.getDateYYYYMMDD(eDate),
                                time: eDate.getHours() +""+(eDate.getMinutes()<=9? "0" +eDate.getMinutes():eDate.getMinutes()),
                            },
                        }
                        if (i==0){
                            this.flightDetails.flightsOfDeparture.push(seg);
                        }else {
                            this.flightDetails.flightsOfReturn.push(seg);
                        }
                    });                    
                }

            }
            this.setLoaderPercent(1,30);
        },
        getPaymentOptions(){
            PassengerService.getPaymentOptions(this.sid).then(rslt=>{
                this.paymentOptions = [];
                if (rslt.data!=null&&rslt.data.length>0){
                    
                    rslt.data.forEach(pmOpt => {
                        let tPm = {
                                merchantCode: pmOpt.MerchantCode,
                                paymentCode: pmOpt.PaymentCode,
                                farePrice:pmOpt.FarePrice,
                                processingFee: pmOpt.Free,
                                grandTotal: pmOpt.GrandTotal,
                                currency:pmOpt.Currency,
                                imageUrls:pmOpt.ImageLogoPaths,
                                paymentCondition:pmOpt.PaymentCondition,
                                amexPaymentCode: pmOpt.AmexPaymentCode,
                                amexActiveByAdmin: pmOpt.AmexActiveByAdmin,
                        };

                        if (pmOpt.PaymentCode=="BANK TRANSFER"){
                            this.paymentOptions.transfer = tPm;           
                            this.bookingInfo.Payment.Banks = pmOpt.BankAccounts;              
                        }else if (pmOpt.PaymentCode=="CREDIT CARD"){
                            this.paymentOptions.card=tPm;                             
                        }else if (pmOpt.PaymentCode.indexOf("_QR_")>=0){
                            tPm.imageUrls = ["QR|"+Helper.logos.qrCode.thaiQrPayment()];
                            this.paymentOptions.qrCode=tPm;                             
                        }
                    });
                }
                this.setLoaderPercent(2,18);
                setTimeout(() => {
                    this.setLoaderPercent(2,2);
                }, 1000);                              
            });  
        },       
    },
}
</script>

<style>

</style>